import { render, staticRenderFns } from "./player_of_the_month.vue?vue&type=template&id=285a3551&scoped=true&"
import script from "./player_of_the_month.vue?vue&type=script&lang=js&"
export * from "./player_of_the_month.vue?vue&type=script&lang=js&"
import style0 from "./player_of_the_month.vue?vue&type=style&index=0&id=285a3551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a3551",
  null
  
)

export default component.exports